var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixButton = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? "button" : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, className = _a.className, props = __rest(_a, ["children", "type", "disabled", "onClick", "className"]);
    var uiTheme = useDataUiTheme();
    return (React.createElement("button", __assign({ ref: ref, type: type, disabled: disabled, onClick: onClick, className: className }, props, { "data-ui-theme": uiTheme }), children));
});
RadixButton.displayName = "RadixButton";
